// Both the send response and socket echo describe the same persisted message.
export const mergeMessages = (...lists) => {
  const messages = new Map();
  for (const list of lists) {
    for (const message of list || []) {
      if (!message?.id) continue;
      messages.set(message.id, { ...messages.get(message.id), ...message });
    }
  }
  return [...messages.values()].sort(
    (a, b) => new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime()
  );
};

export const mergeMessagePage = (page, { data } = {}) => ({
  ...page,
  data: mergeMessages(page.data, data?.data)
});

export const settleOptimisticMessage = (messages, pendingId, message) =>
  mergeMessages(messages?.filter((item) => item.id !== pendingId), [message]);

export const readFailedMessages = (storage, key) => {
  try {
    const messages = JSON.parse(storage.getItem(key) || '[]');
    return Array.isArray(messages) ? messages : [];
  } catch (_) {
    return [];
  }
};

export const writeFailedMessages = (storage, key, messages) =>
  storage.setItem(key, JSON.stringify(messages));

export const mergeFailedMessagePage = (page, options, failedMessages) => {
  const merged = mergeMessagePage(page, options);
  return { ...merged, data: mergeMessages(merged.data, failedMessages) };
};

// Socket.IO retains listeners through disconnects and reconnects. Register even
// before connecting, and remove only the callbacks owned by this subscription.
export const subscribeSocketListeners = (socket, listeners, removeListeners = {}) => {
  const callbacks = Object.entries(listeners).map(([name, listener]) => {
    const callback = (...payloads) => listener?.(...payloads);
    socket.on(name, callback);
    return [name, callback];
  });
  return () => {
    for (const [name, callback] of callbacks) {
      socket.removeListener(name, callback);
      removeListeners[name]?.();
    }
  };
};
